import { CsiImage, Text } from "designSystem/index";
import { ATTR_IMAGES } from "csi/model/image";
import { C8Node } from "csi/typings";
import xml from "csi/xml";
import React, { useState } from "react";
import CssColumnGrid from "../../CssColumnGrid";
import blackImage from "../colorchiparray/Black.jpg";
import blueImage from "../colorchiparray/Blue.jpg";
import greenImage from "../colorchiparray/Green.jpg";
import greyImage from "../colorchiparray/Grey.jpg";
import redImage from "../colorchiparray/Red.jpg";
import silverImage from "../colorchiparray/Silver.jpg";
import yellowImage from "../colorchiparray/Yellow.jpg";

// mock nodes
const nodeWithoutImages = xml.nodeCreateClientNode();
const nodeWithImages = xml.nodeCreateClientAttr(xml.nodeCreateClientNode(), ATTR_IMAGES, xml.ATTR_REFMAP, {
	"": blueImage,
	Red: redImage,
	Green: greenImage,
	1: blackImage,
	2: blueImage,
	3: greenImage,
	4: greyImage,
	5: redImage,
	6: silverImage,
	7: yellowImage,
});

// mock function to extract src - not needed in client when using real nodes and connected to the server
const sourceFunction = (node: C8Node, key: string, containerHeight: number, containerWidth: number) => {
	return node.Images?.[key];
};

export default () => {
	const [over, setOver] = useState(false);

	return (
		<CssColumnGrid columns={4}>
			<Text semiBold text="no image" />
			<Text semiBold text="labeled image" />
			<Text semiBold text="all images fixed controls" />
			<Text semiBold text="all images hover controls" />
			<CsiImage node={nodeWithoutImages} />
			<CsiImage
				imageLabel="Red"
				imageSrcFunction={sourceFunction}
				node={nodeWithImages}
			/>
			<CsiImage
				allowSwitchNodeImages
				displayControls
				imageSrcFunction={sourceFunction}
				node={nodeWithImages}
			/>
			<CsiImage
				allowSwitchNodeImages
				displayControls={over}
				imageSrcFunction={sourceFunction}
				node={nodeWithImages}
				onMouseEnter={() => setOver(true)}
				onMouseLeave={() => setOver(false)}
			/>
		</CssColumnGrid>
	);
};